<template>
	<div class="ao-preview-advanced-header d-flex">

		<img
			v-if="imgSrc"
			:src="imgSrc"
			class="mr-4 header-image"
		/>

		<ao-icon
			v-if="icon"
			:iconName="icon"
			:size="iconSize"
			class="mr-2 my-auto"
		/>

		<div class="flex-grow-1">

			<slot name="title">
				<div class="ao-h2 mb-1 text-textBody">
					<slot name="title-content">
						{{ title }}
					</slot>
				</div>
			</slot>

			<template v-if="subTitle">
				<slot name="subtitle">
					<div class="ao-p2-medium text-textSecondary700">
						<slot name="subtitle-content">
							{{ subTitle }}
						</slot>
					</div>
				</slot>
			</template>

			<template v-if="params.length">
				<slot name="params">
					<div class="d-flex flex-wrap ga-3">
						<div
							v-for="item in params"
							:key="item.key"
							:class="item.paramClass"
							class="d-flex"
						>
							<slot
								:name="`param--${item.key}`"
								:item="item"
								:key="item.key"
							>
								<ao-icon
									v-if="item.iconName"
									:iconName="item.iconName"
									class="me-1"
								/>
								<span class="ao-p4-medium text-textBody text-no-wrap">{{ item.title }}</span>
							</slot>
						</div>
					</div>
				</slot>
			</template>

		</div>

		<!-- TODO: реализовать вывод массива статусов -->
		<!-- <PreviewStatus
			v-if="status"
			class="mb-4"
			:status="status"
			color="green"
		/> -->

	</div>
</template>

<script setup>
import PreviewStatus from '@/components/ui/preview/PreviewStatus.vue'

defineProps({
	title: {
		type: String,
		required: true,
	},

	imgSrc: {
		type: String,
		default: null,
	},

	icon: {
		type: String,
		default: null,
	},

	iconSize: {
		type: String,
	},

	subTitle: {
		type: String,
		default: null,
	},

	/* [{
		key: [String, Number], // required
		title: String, // required
		iconName: String,
	}, ...] */
	params: {
		type: Array,
		default: () => ([]),
	},

	// status: {
	// 	type: String,
	// },
})
</script>

<style lang="scss">
.ao-preview-advanced-header {

	.header-image {
		max-width: 64px;
		max-height: 64px;
		width: 100%;
	}

}
</style>
